import { useMutation } from '@tanstack/react-query';

import { ApiErrorCode, createApiError } from '@/modules/common/api/errors';
import { useApiError } from '@/modules/common/hooks/use-api-error';

import { getTeamMemberBillingConflicts } from '../../api/team.api';
import {
  CheckConflictsParams,
  CheckConflictsResult,
  TeamMemberConflictResolutionData,
} from '../../types/team-member-conflicts';

export const useCheckTeamMemberBillingConflicts = () => {
  const { displayToastErrorFromApiWithFallback } = useApiError();

  const mutation = useMutation({
    mutationFn: async ({
      teamMemberId,
      startDate,
      endDate,
    }: CheckConflictsParams): Promise<CheckConflictsResult> => {
      const conflictData: TeamMemberConflictResolutionData = await getTeamMemberBillingConflicts({
        teamMemberId: Number(teamMemberId),
        startDate,
        endDate,
      });

      return {
        items: conflictData.items,
        hasConflicts: conflictData.hasConflicts,
      };
    },
    onError: error => {
      const apiError = createApiError(
        ApiErrorCode.TEAM_MEMBER_BILLING_CONFLICTS_LOAD_FAILED,
        error
      );
      displayToastErrorFromApiWithFallback(
        apiError,
        'authenticated.team:api.error.billingConflictsLoadFailed'
      );
    },
  });

  return {
    checkConflicts: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
};
